import { render, staticRenderFns } from "./LastBuy.vue?vue&type=template&id=142b52da&scoped=true"
import script from "./LastBuy.vue?vue&type=script&lang=js"
export * from "./LastBuy.vue?vue&type=script&lang=js"
import style0 from "./LastBuy.vue?vue&type=style&index=0&id=142b52da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142b52da",
  null
  
)

export default component.exports